/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_More_TitleInputs */

const da_consent_more_title = /** @type {(inputs: Consent_More_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mere information`)
};

/** @type {(inputs: Consent_More_TitleInputs) => LocalizedString} */
const en_consent_more_title = da_consent_more_title;

/**

* @param {Consent_More_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_more_title = /** @type {((inputs?: Consent_More_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_More_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_more_title(inputs)
	return /** @type {LocalizedString} */ ("Mere information")
});